"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HierarchicalMenu = HierarchicalMenu;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _cx = require("./lib/cx");

var _isModifierClick = require("./lib/isModifierClick");

var _ShowMoreButton = require("./ShowMoreButton");

var _excluded = ["classNames", "items", "hasItems", "onNavigate", "createURL", "showMore", "canToggleShowMore", "onToggleShowMore", "isShowingMore", "translations"];

function HierarchicalList(_ref) {
  var className = _ref.className,
      _ref$classNames = _ref.classNames,
      classNames = _ref$classNames === void 0 ? {} : _ref$classNames,
      items = _ref.items,
      createURL = _ref.createURL,
      onNavigate = _ref.onNavigate;
  return /*#__PURE__*/_react.default.createElement("ul", {
    className: (0, _cx.cx)('ais-HierarchicalMenu-list', classNames.list, className)
  }, items.map(function (item) {
    return /*#__PURE__*/_react.default.createElement("li", {
      key: item.value,
      className: (0, _cx.cx)('ais-HierarchicalMenu-item', classNames.item, item.data && (0, _cx.cx)('ais-HierarchicalMenu-item--parent', classNames.parentItem), item.isRefined && (0, _cx.cx)('ais-HierarchicalMenu-item--selected', classNames.selectedItem))
    }, /*#__PURE__*/_react.default.createElement("a", {
      className: (0, _cx.cx)('ais-HierarchicalMenu-link', classNames.link, item.isRefined && (0, _cx.cx)('ais-HierarchicalMenu-link--selected', classNames.selectedItemLink)),
      href: createURL(item.value),
      onClick: function onClick(event) {
        if ((0, _isModifierClick.isModifierClick)(event)) {
          return;
        }

        event.preventDefault();
        onNavigate(item.value);
      }
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: (0, _cx.cx)('ais-HierarchicalMenu-label', classNames.label)
    }, item.label), /*#__PURE__*/_react.default.createElement("span", {
      className: (0, _cx.cx)('ais-HierarchicalMenu-count', classNames.count)
    }, item.count)), item.data && /*#__PURE__*/_react.default.createElement(HierarchicalList, {
      className: (0, _cx.cx)('ais-HierarchicalMenu-list--child', classNames.childList),
      classNames: classNames,
      items: item.data,
      onNavigate: onNavigate,
      createURL: createURL
    }));
  }));
}

function HierarchicalMenu(_ref2) {
  var _ref2$classNames = _ref2.classNames,
      classNames = _ref2$classNames === void 0 ? {} : _ref2$classNames,
      items = _ref2.items,
      hasItems = _ref2.hasItems,
      onNavigate = _ref2.onNavigate,
      createURL = _ref2.createURL,
      showMore = _ref2.showMore,
      canToggleShowMore = _ref2.canToggleShowMore,
      onToggleShowMore = _ref2.onToggleShowMore,
      isShowingMore = _ref2.isShowingMore,
      translations = _ref2.translations,
      props = (0, _objectWithoutProperties2.default)(_ref2, _excluded);
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, props, {
    className: (0, _cx.cx)('ais-HierarchicalMenu', classNames.root, !hasItems && (0, _cx.cx)('ais-HierarchicalMenu--noRefinement', classNames.noRefinementRoot), props.className)
  }), /*#__PURE__*/_react.default.createElement(HierarchicalList, {
    classNames: classNames,
    items: items,
    onNavigate: onNavigate,
    createURL: createURL
  }), showMore && /*#__PURE__*/_react.default.createElement(_ShowMoreButton.ShowMoreButton, {
    className: (0, _cx.cx)('ais-HierarchicalMenu-showMore', classNames.showMore, !canToggleShowMore && (0, _cx.cx)('ais-HierarchicalMenu-showMore--disabled', classNames.disabledShowMore)),
    disabled: !canToggleShowMore,
    onClick: onToggleShowMore,
    isShowingMore: isShowingMore,
    translations: translations
  }));
}